<template><p v-html="dataSourceByDataType" class="mobile-footer"></p></template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Disclaimer",
  computed: {
    dataSourceByDataType() {
      let res = "";
      if (this.dataSource) {
        let r = this.dataSource.find((x) => x.dataType === this.dataType);
        if (r) {
          let prefix = this.$t("dashboard").sourceFooterPrefix;
          // this condition is needed to avoid error when dataType is still changing when switching from one source to another
          res = prefix + r.source;
        }
      }
      return res;
    },
    ...mapGetters({ dataSource: "ui/dataSource", dataType: "ui/dataType" }),
  },
};
</script>

<style lang="scss" scoped>
.mobile-footer {
  margin-top: 3.07vh;
  padding: toRem(4) toRem(10);
  background-color: rgba(255, 255, 255, 0.05);
  @include dida-XS;
}

.tablet {
  .mobile-footer {
    padding: 0;
    height: fit-content;
  }
}
</style>
